import React from "react";
import { useTranslation } from "react-i18next";
import ContactForm from "../ContactFrom/ContactForm";
import ContactMap from "./ContactMap";

const Contactpage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <ContactMap />
      <section className="wpo-contact-pg-section section-padding pt-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="wpo-contact-form-area">
                <div className="wpo-contact-title">
                  <h2>{t("contactPage.title")}</h2>
                  <p>{t("contactPage.subtitle")}</p>
                </div>
                <ContactForm />
              </div>
            </div>
            <div className="col col-lg-4">
              <div className="office-info">
                <div className="office-info-item">
                  <div className="office-info-icon">
                    <div className="icon">
                      <i className="fi flaticon-phone-call"></i>
                    </div>
                  </div>
                  <div className="office-info-text">
                    <h2>{t("contactPage.phone")}:</h2>
                    <p>+992928808292</p>
                  </div>
                </div>
                <div className="office-info-item">
                  <div className="office-info-icon">
                    <div className="icon">
                      <i className="fi flaticon-email-3"></i>
                    </div>
                  </div>
                  <div className="office-info-text">
                    <h2>{t("contactPage.email")}:</h2>
                    <p>olamiroh@mail.ru</p>
                  </div>
                </div>

                <div className="office-info-item">
                  <div className="office-info-icon">
                    <div className="icon">
                      <i className="fi flaticon-location-1"></i>
                    </div>
                  </div>
                  <div className="office-info-text">
                    <h2>{t("contactPage.location")}:</h2>
                    <p>{t("contactPage.address")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contactpage;
